import { ValidationError } from "../types/ApiClient";

class SubmissionError extends Error {
  public errors: ValidationError[];

  constructor(errors: ValidationError[]) {
    super("Submit Validation Failed");
    this.errors = errors;
    this.name = "SubmissionError";
  }
}

export default SubmissionError;
